// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MensagensProgramadas_BuscaWhatsappDevicesResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for buscaWhatsappDevices() /mensagens_programadas/buscaWhatsappDevices
 * Returns an array of WhatsApp devices.
 * Overrides getDados() to return the flat array directly (wire-shape preservation for DataTable).
 */
import type { MensagensProgramadas_DeviceRow } from './MensagensProgramadas_DeviceRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type MensagensProgramadas_BuscaWhatsappDevicesResponseDados = MensagensProgramadas_DeviceRow[];

export type MensagensProgramadas_BuscaWhatsappDevicesResponse = ApiResponse<MensagensProgramadas_BuscaWhatsappDevicesResponseDados>;

registerResponseContract('MensagensProgramadas_BuscaWhatsappDevicesResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      id:            { type: 'string',  required: true },
      instance_name: { type: 'string',  required: true },
      franquia_nome: { type: 'string',  required: true },
      display_name:  { type: 'string',  required: true },
    },
  },
})
